import React from 'react';

import { useWizard } from '../../AccomodationModal/hooks';
import { useContentSubmitHandlers } from '../shared';
import * as types from './types';

export const activityWizardContext = React.createContext<types.TActivityWizardContext>(
  {} as types.TActivityWizardContext,
);

export const ActivityWizardContextProvider = ({
  children,
  tripEvent,
  onSubmit,
}: React.PropsWithChildren<types.IActivityTripEventModalContentProps>) => {
  const [detailsFormProps, setDetailsFormProps] = React.useState<types.TActivityWizardContext['detailsFormProps']>({});

  const wizard = useWizard<types.TActivityWizardData>(['default', 'details', 'page'], {
    default: tripEvent,
    details: undefined,
    page: undefined,
  });

  React.useEffect(() => {
    // reset data on 'details' and 'page' after navigate on default scene
    if (wizard.step === 'default') {
      wizard.updateData('details', undefined);
      wizard.updateData('page', undefined);
    }
  }, [wizard.step]);

  const { handleDetailsSubmit, handlePageSubmit } = useContentSubmitHandlers({ wizard });

  return (
    <activityWizardContext.Provider
      value={{
        ...wizard,
        tripEvent,

        onSubmit,
        handlePageSubmit,
        handleDetailsSubmit,

        detailsFormProps,
        setDetailsFormProps,
      }}
    >
      {children}
    </activityWizardContext.Provider>
  );
};

export const useActivityWizardContext = () => React.useContext(activityWizardContext);

export const withWizardContext = (WrappedComponent: React.ComponentType) => {
  return function (props: types.IActivityTripEventModalContentProps) {
    return (
      <ActivityWizardContextProvider {...props}>
        <WrappedComponent />
      </ActivityWizardContextProvider>
    );
  };
};
